import React, { Component, Fragment } from 'react';
import './stage1-new.css';
import { updateObject } from "../../js/actions/index";
import store from "../../js/store/index";
import { VisibilityFilters } from "../../js/constants/action-types";
import { setVisibilityFilter } from "../../js/actions/index";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

function mapDispatchToProps(dispatch) {
  return {
    updateObject: article => dispatch(updateObject(article)),
  };
}

class Stage1New extends Component {

  constructor(props) {
    super(props);
    console.log(props);
    this.state = { appState: store.getState(), nextButtonClass: '', subheaderText: 'Help us find the right property for you', welcomeBackHeader: '' };
    this.handleChange = this.handleChange.bind(this)
    this.gotoStage2 = this.gotoStage2.bind(this)
  }

  componentDidMount() {
    if (this.state.appState.whyPad.newCustomer.existingCustomer === "1") {
      this.setState({ subheaderText: 'Thanks for coming back, help us fill in the gaps....', welcomeBackHeader: 'We have filled in what we know from previous communications, if there have been any changes please update them to reflect your current search'})
    }
    if (this.state.appState.whyPad.newCustomer.whyMoving !== "" && this.state.appState.whyPad.newCustomer.whenMove !== "") {
      this.setState({ nextButtonClass: 'activeButton' })
    } else {
      this.setState({ nextButtonClass: 'disabledButton' })
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value })
    this.state.appState.whyPad.newCustomer[event.target.name] = event.target.value;

    if (this.state.appState.whyPad.newCustomer.whyMoving !== "" && this.state.appState.whyPad.newCustomer.whenMove !== "") {
      this.setState({ nextButtonClass: 'activeButton' })
    } else {
      this.setState({ nextButtonClass: 'disabledButton' })
    }
    console.log(this.state);
  }

  gotoStage2() {
    store.dispatch(setVisibilityFilter(VisibilityFilters.SHOW_STAGE2))
  }

  render() {
    return (
      <Fragment>
        <div className="row valFormWidth" style={{ background: 'transparent', padding: '20px 30px', opacity: '0.95', margin: '0 auto' }}>
          <div className="row pageHeader">
              <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: '10px', paddingLeft: '0px'}}>
                  <label style={{fontWeight: 'bold', marginBottom: '0px'}}>Tell us more about your move</label>
              </div>
          </div>
          <div className="row pageSubHeader">
            <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingBottom: '10px', paddingLeft: '0px'}}>
              <label style={{ fontWeight: 'bold' }}>{this.state.subheaderText}</label>
            </div>
          </div>
          <div style={{ background: 'white', textAlign: 'center', border: '1.1px solid lightgray', borderRadius: '16px', marginTop: '15px', width: '100%' }}>
            { this.state.welcomeBackHeader !== '' ? <div className="col-md-12 col-sm-12 col-xs-12" style={{ paddingLeft: '0px'}}>
              <label style={{ fontWeight: 'bold', fontSize: '14px', padding: '20px', paddingBottom: '0px', color: '#ec008c', marginBottom: '0px' }}>{this.state.welcomeBackHeader}</label>
            </div> : null }
            <div className="row" style={{ margin: '0px' }}>
              <img className="imageStyle" src={require("../../assets/images/stage1New.png")}></img>
            </div>
            <div className="row" style={{ margin: '10px auto', color: '#401663', width: '80%', fontWeight: 'bold', marginBottom: '0px' }}>
              <p style={{ marginBottom: '10px' }}>Why are you moving?</p>
            </div>
            <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto' }}>
              <input className="form-control searchBoxText" placeholder="Job change, relocating moving to be near family..." type="text" style={{ borderRadius: '12px' }} name="whyMoving" value={this.state.appState.whyPad.newCustomer.whyMoving} onChange={this.handleChange}></input>
            </div>
            <div className="row" style={{ margin: '30px auto 0px', color: '#401663', width: '80%', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '10px' }}>When would you like to move?</p>
            </div>
            <div className="row" style={{ margin: '0px', width: '80%', margin: '0 auto' }}>
              <select name="title" style={{ top: '2px', fontSize: '14px', minHeight: '38px', width: '100%', paddingLeft: '.83333em',  border: '1px solid lightgray', borderRadius: '12px' }} value={this.state.appState.whyPad.newCustomer.whenMove} name="whenMove" onChange={this.handleChange}>
                <option value="">Please select an option</option>
                <option value="Now">NOW</option>
                <option value="2-3 Months">2-3 months</option>
                <option value="3-6 Months">3-6 months</option>
                <option value="6+ Months">6 months +</option>
              </select>
            </div>
            <div className="row" style={{ width: '50%', margin: '30px auto 0px', borderRadius: '32px' }} className={this.state.nextButtonClass}>              
              <div onClick={() => { this.gotoStage2() }} className="form-control"  style={{ borderRadius: '32px', borderLeft: 'none', marginBottom: '20px', height: '50px', paddingTop: '10px', background: 'transparent' }}>
                <a style={{ color: 'white', fontWeight: 'bold' }}  type="button">NEXT</a>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Stage1New;